var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServices3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "services3",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 54.295,
    height: 54.295,
    viewBox: "0 0 54.295 54.295",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9f78ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f067ff"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M51.114,25.345a3.185,3.185,0,0,0,3.181-3.181V3.181A3.185,3.185,0,0,0,51.114,0H3.181A3.185,3.185,0,0,0,0,3.181V22.163a3.185,3.185,0,0,0,3.181,3.181h9.65V28.95H3.181A3.185,3.185,0,0,0,0,32.132V51.114a3.185,3.185,0,0,0,3.181,3.181H51.114a3.185,3.185,0,0,0,3.181-3.181V32.132a3.185,3.185,0,0,0-3.181-3.181h-9.65V25.345ZM3.181,3.181H51.114l0,18.982c-.011,0-9.463,0-47.934,0ZM51.116,51.113c-.011,0-9.463,0-47.934,0V32.132H51.114ZM38.282,28.95H16.013V25.345H38.282Z",
    fill: "url(#linear-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M334.832,76.665A5.832,5.832,0,1,0,329,70.832,5.839,5.839,0,0,0,334.832,76.665Zm0-8.484a2.651,2.651,0,1,1-2.651,2.651A2.654,2.654,0,0,1,334.832,68.181Z",
    transform: "translate(-294.111 -58.107)",
    fill: "url(#linear-gradient)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M68.287,65h-1.7a1.591,1.591,0,0,0,0,3.181h1.7a1.591,1.591,0,0,0,0-3.181Z",
    transform: "translate(-58.107 -58.107)",
    fill: "url(#linear-gradient)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M68.287,145h-1.7a1.591,1.591,0,0,0,0,3.181h1.7a1.591,1.591,0,1,0,0-3.181Z",
    transform: "translate(-58.107 -129.624)",
    fill: "url(#linear-gradient)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M146.591,68.181h1.7a1.591,1.591,0,1,0,0-3.181h-1.7a1.591,1.591,0,0,0,0,3.181Z",
    transform: "translate(-129.624 -58.107)",
    fill: "url(#linear-gradient)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M146.591,148.181h1.7a1.591,1.591,0,1,0,0-3.181h-1.7a1.591,1.591,0,0,0,0,3.181Z",
    transform: "translate(-129.624 -129.624)",
    fill: "url(#linear-gradient)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M226.591,68.181h1.7a1.591,1.591,0,1,0,0-3.181h-1.7a1.591,1.591,0,1,0,0,3.181Z",
    transform: "translate(-201.14 -58.107)",
    fill: "url(#linear-gradient)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M226.591,148.181h1.7a1.591,1.591,0,1,0,0-3.181h-1.7a1.591,1.591,0,1,0,0,3.181Z",
    transform: "translate(-201.14 -129.624)",
    fill: "url(#linear-gradient)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M329,342.832A5.832,5.832,0,1,0,334.832,337,5.839,5.839,0,0,0,329,342.832Zm5.832-2.651a2.651,2.651,0,1,1-2.651,2.651A2.654,2.654,0,0,1,334.832,340.181Z",
    transform: "translate(-294.111 -301.263)",
    fill: "url(#linear-gradient)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M68.287,337h-1.7a1.591,1.591,0,0,0,0,3.181h1.7a1.591,1.591,0,0,0,0-3.181Z",
    transform: "translate(-58.107 -301.263)",
    fill: "url(#linear-gradient)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M68.287,417h-1.7a1.591,1.591,0,0,0,0,3.181h1.7a1.591,1.591,0,0,0,0-3.181Z",
    transform: "translate(-58.107 -372.779)",
    fill: "url(#linear-gradient)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M148.287,337h-1.7a1.591,1.591,0,0,0,0,3.181h1.7a1.591,1.591,0,1,0,0-3.181Z",
    transform: "translate(-129.624 -301.263)",
    fill: "url(#linear-gradient)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M148.287,417h-1.7a1.591,1.591,0,0,0,0,3.181h1.7a1.591,1.591,0,1,0,0-3.181Z",
    transform: "translate(-129.624 -372.779)",
    fill: "url(#linear-gradient)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M228.287,337h-1.7a1.591,1.591,0,1,0,0,3.181h1.7a1.591,1.591,0,1,0,0-3.181Z",
    transform: "translate(-201.14 -301.263)",
    fill: "url(#linear-gradient)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M228.287,417h-1.7a1.591,1.591,0,1,0,0,3.181h1.7a1.591,1.591,0,1,0,0-3.181Z",
    transform: "translate(-201.14 -372.779)",
    fill: "url(#linear-gradient)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServices3);
export default __webpack_public_path__ + "static/media/services3.42f8e397cb47a7e36c74b2b93d0bf4d7.svg";
export { ForwardRef as ReactComponent };